import React from 'react';
import PropTypes from 'prop-types';

import styles from './CreditBreakdownTable.scss';

export default function CreditBreakdownTable({ heading, items }) {
  return (
    <div className={styles.creditBreakdownTable}>
      <h4 className={styles.heading}>{heading}</h4>

      <table className={styles.items}>
        <tbody>
          {items.map((item) => (
            <tr key={`details-item-${item.key}`}>
              <th scope="row">{item.key}</th>
              <td>{item.value}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

CreditBreakdownTable.propTypes = {
  heading: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
